import styled from 'styled-components';

export const ListCard = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 24px;
`;

export const ErrorText = styled.div`
    color: #f10b3c;
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 12px;
    padding: 2px 16px;
`;

export const CardTitle = styled.div`
    margin-bottom: 10px;
`;

export const CardContent = styled.div`
    max-height: 380px;
    overflow: auto; 
    border: ${props => props.error ? "solid 1px #f10b3c" : "none"};
    border-radius: 12px;
`;